import moment from 'moment'

function fecha(valor) {
    const fecha = moment.parseZone(valor || '', moment.ISO_8601, true)
    return fecha.isValid() ? fecha.format('YYYY-MM-DD') : null
}

function monto(valor) {
    if (valor === '' || valor == null) return null
    const numero = Number(valor)
    return Number.isFinite(numero) ? numero : null
}

export function revisarLiquidaciones(liquidaciones) {
    const alertas = []
    for (const liquidacion of liquidaciones) {
        for (const recibo of liquidacion.recibos) {
            const persona = recibo.persona || {}
            const agregar = (campo, sistema, excel) => alertas.push({
                numero_liquidacion: liquidacion.numero,
                periodo: liquidacion.periodo,
                numero_legajo: recibo.numero_legajo,
                nombre: recibo.nombre,
                campo, sistema, excel
            })
            const fechaSistema = fecha(persona.fecha_ingreso)
            const fechaExcel = fecha(recibo.fecha_ingreso)
            if (fechaSistema !== fechaExcel) {
                agregar('fecha_ingreso', fechaSistema, fechaExcel)
            }

            // El básico del recibo se toma siempre del legajo. La base de
            // Holistor puede faltar o ser proporcional: no es comparable.
            const basicoSistema = monto(persona.categoria && persona.categoria.total)
            if (basicoSistema === null) {
                agregar('sueldo_basico_legajo_sin_dato', null, null)
            }
        }
    }
    return alertas
}
